export const PO_COMPLETE_DOCUMENT_FIRST_PAGE_FIT_ALL_CONTENT_THRESHOLD = 5;
export const PO_COMPLETE_DOCUMENT_OTHER_PAGE_FIT_ALL_CONTENT_THRESHOLD = 10;

export const PO_COMPLETE_DOCUMENT_FIRST_PAGE_TABLE_ROW_LENGTH = 14;
export const PO_COMPLETE_DOCUMENT_OTHER_PAGE_TABLE_ROW_LENGTH = 18;

export const PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_NAME_CELL_WIDTH = 290;
export const PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_WARRANTY_CELL_WIDTH = 110;
export const PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_QTY_CELL_WIDTH = 40;
export const PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_SEPARATOR_CELL_WIDTH = 40;
export const PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_PRICE_CELL_WIDTH = 90;
